import React, {Component} from 'react';
import Btn from "../btn";
import Dialog, {DIALOG_TYPE_THUMBS} from "../dialog";
import './thanks.css';

class Thanks extends Component {

    render() {
        const body =
            <div className="Thanks">
                <p>{'Vaše odpovědi nám právě dorazily. Chceme se neustále zlepšovat, a proto si vážíme zpětné vazby. Vaše hodnocení předáme členům týmu, kteří na Vašem projektu pracovali.'}</p>
                <p>{'Sledujte co se děje online i u nás v AITOMu'}</p>
                <div className="Thanks__btn">
                    <Btn text={'Přečíst si blog'} href={'https://www.aitom.cz/co-je-noveho'}/>
                </div>
            </div>;

        return <Dialog title={'Děkujeme za Vaše hodnocení'} type={DIALOG_TYPE_THUMBS} body={body}/>;
    }

}


export default Thanks;


// WEBPACK FOOTER //
// ./src/components/thanks/index.js